import { ErrorMessage } from '@hookform/error-message'
import { Stack, TextField, TextFieldProps, Typography } from '@mui/material'
import {
  Controller,
  FieldErrors,
  FieldPath,
  FieldValues,
  UseControllerProps,
} from 'react-hook-form'

type Props<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = UseControllerProps<TFieldValues, TName> & TextFieldProps & { errors: FieldErrors<TFieldValues> }

export const ControlledTextField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  name,
  label,
  size,
  variant,
  errors,
  multiline,
  fullWidth,
  disabled,
  required,
  helperText,
  type,
}: Props<TFieldValues, TName>) => {
  return (
    <Stack gap={0.5} flex={1}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <TextField
            {...field}
            value={field.value || ''}
            label={label}
            size={size || 'small'}
            variant={variant}
            multiline={multiline}
            fullWidth={fullWidth}
            disabled={disabled}
            required={required}
            helperText={helperText}
            type={type}
          />
        )}
      />
      {Object.keys(errors).length > 0 ? (
        <ErrorMessage
          errors={errors}
          // @ts-expect-error no idea yet
          name={name}
          render={({ message }) => (
            <Typography color="error" variant="body2">
              {message}
            </Typography>
          )}
        />
      ) : null}
    </Stack>
  )
}
